module.exports = __webpack_public_path__ + "assets/img/376669870d7fb4495d8d29b148c41de2.png";